import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    root: {
        textTransform: 'initial',
        padding:'7px 39px'
    }
}